/* src/app/features/tarefas/cobranca/tarefas-cobranca.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 820px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 817px;
  font-weight: bold;
}
.d-flex.title3 {
  padding-right: 801px;
  font-weight: bold;
}
.d-flex.title4 {
  padding-right: 777px;
  font-weight: bold;
}
/*# sourceMappingURL=tarefas-cobranca.component.css.map */
